<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top" v-if="viewModel">
    <h4 class="modal-title">通知を作成 {{treePlace}}</h4>
  </div>
  <div class="p-3" v-if="viewModel">
    <h4 class="formInput-section">通知分類</h4>
    <el-select placeholder="" v-model="viewModel.title" @change="changeType">
      <el-option v-for="item in NoticeClassList"
                class="select-primary"
                :value="item.label"
                :label="item.label"
                :key="item.label">
      </el-option>
    </el-select>
    <h4 class="formInput-section">内容</h4>
    <el-input
      placeholder="テキストで入力"
      clearable
      type="textarea"
      v-model="viewModel.contents"
    ></el-input>
    <h4 class="formInput-section">対象者</h4>
    <div class="my-box pl-1">
      <div>
      
      <base-button
        type="primary"
        @click="onClickUserSelect"
        ><i class="fas fa-plus"></i>ユーザーを選択
        </base-button>
        </div>

      <div class="pt-2">
        <el-tag
          class="mr-1 mb-1"
          v-for="user in targetUsers"
          :key="user.userId"
          @close="removeUser(user)"
          closable
        >
          {{ trimString(user.name, 10) }}
        </el-tag>
      </div>
    </div>
    
    <div class="d-flex mt-4">
      <div class="my-box flex-fill pr-1">
        <base-button
          block
          type="secondary"
          @click="onClickCancel"
          v-if="!isNewProject"
          >キャンセル</base-button
        >
      </div>
      <div class="my-box flex-fill pl-1">
        <base-button
          block
          type="primary"
          @click="onClickSave"
          v-if="!isNewProject"
          >通知</base-button
        >
      </div>
    </div>
  </div>
  
  <modal v-model:show="memberModal" size="lg" style="z-index:1051 !important;" body-classes="p-0">    
    <general-member-modal v-if="memberModal" @onAdd="onClickMemberModalAdd" @onCancel="onClickMemberModalCancel" />
  </modal>

  <!-- 確認用モーダル -->
    <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1051 !important;" body-classes="p-0">
      <confirm-modal 
        :title="confirm.title"
        :message="confirm.message" 
        :leftButtonLabel="confirm.leftButtonLabel" 
        :rightButtonLabel="confirm.rightButtonLabel" 
        @onClickLeftButton="onClickConfirmLeft"
        @onClickRightButton="onClickConfirmRight"
       />
    </modal>
</template>

<style>
</style>
<script>
import Session from "@/appSession/Session"
import InspectPlaceNoticeViewModel from "@/appViews/InspectPlace/ViewModel/InspectPlaceNoticeViewModel"
import GeneralMemberModal from "@/appViews/General/GeneralMemberModal"

export default {
  components: {
    GeneralMemberModal
  },
  watch: {
    viewModel: {
      handler: function () {
        this.modified = true
        this.isDefaultContent = false
      },
      deep: true
    }
  },
  data() {
    return {
      tenantId: "",
      modified: false,
      userSub: "",
      session: null,
      viewModel: null,
      NoticeClassList: [{label: "確認依頼"}, {label: "指示"}, {label: "確認"}],
      defaultContents: {},
      memberModal: false,
      targetUsers: [],
      isDefaultContent: true,
      showConfirm: false,
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      treePlace: "",
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    this.init().then(() => {
      console.log(`init end`)
    })
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      // if (!this.$store.state.session.id) {
      //   // セッションIDがない場合はログイン画面に遷移する
      //   this.$router.push({
      //     name: 'Signin'
      //   })
      // }

      // this.session = await Session.init(this.$store.state.session.id)
      // console.log(`session: ${JSON.stringify(this.session.info)}`)
      const userInfo = await this.$root.getUserInfo()
      this.tenantId = userInfo.group
      this.userSub = userInfo.sub
      // 関連するパラメータをセット
      let notice = this.$store.state.notice
      this.treePlace = notice.treePlace
      // 箇所通知登録のViewModel
      this.viewModel = await InspectPlaceNoticeViewModel.init(this.tenantId, this.userSub, notice.linkedId, notice.treePlace)
      this.modified = false

      this.defaultContents = []
      let loginUserName = this.viewModel.userDictionary[this.userSub].name
      this.NoticeClassList.forEach(function(item){
        this.defaultContents[item.label] = `${loginUserName}からの${item.label}です。`
      }.bind(this));
      
    },
    onClickCancel() {
      if (this.modified) {
        // 変更確認
        this.confirm.message = `変更内容が破棄されますがよろしいですか？`
        this.confirm.leftButtonLabel = "編集に戻る"
        this.confirm.rightButtonLabel = "破棄する"
        this.confirm.leftButtonFn = function() {
          this.showConfirm = false
        }.bind(this)
        this.confirm.rightButtonFn = function() {
          this.showConfirm = false
          
          this.$emit('noticeCancel');
        }.bind(this)
        this.showConfirm = true
      } else {
        
        this.$emit('noticeCancel');
      }
      
    },
    /**
     * 確認ダイアログの左側ボタン押下時
     */
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    /**
     * 確認ダイアログの右側ボタン押下時
     */
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    onClickMemberModalAdd(selectedUsers) {
      this.memberModal = false
      this.targetUsers = []
      for (let i = 0;i < selectedUsers.length; i++) {
        this.targetUsers.push({userId: selectedUsers[i].user.userId, name: selectedUsers[i].user.name})
      }
    },
    onClickMemberModalCancel() {
      this.memberModal = false
    },
    onClickUserSelect() {
      this.memberModal = true
    },
    removeUser(user) {
      console.log(`removeUser ${JSON.stringify(user)}`)
      let index = this.targetUsers.findIndex((v) => v.userId === user.userId)
      console.log(`removeUser ${index}`)
      if (index >= 0) {
        this.targetUsers.splice(index, 1)
      }
    },
    changeType(value) {
      // 内容が未入力であれば自動セットする
      this.setContentDefault(value)
      
    },
    setContentDefault(value) {

      let isDefault = false
      
      for (let key in this.defaultContents) {
        if (this.viewModel.contents == this.defaultContents[key]) {
          isDefault = true
          break
        }
      } 
      if (isDefault || !this.viewModel.contents) {
        this.viewModel.contents = `${this.viewModel.userDictionary[this.userSub].name}からの${value}です。`
      }
    },
    trimString(value, max) {
      let leader = ""
      if (value.length > max) {
        leader = "..."
      }
      return value.substr(0, max) + leader
    },
    async onClickSave() {
      
      // 対象ユーザのuserId(sub)だけで配列を作成してviewmodelにセットする
      this.viewModel.targetUsers = this.targetUsers.map(item => item.userId)

      let result = await this.viewModel.save()
      this.memberModal = false
      this.$emit('noticeSave');

    }
  }
};
</script>
